import { render, staticRenderFns } from "./EstimateTemplateNew.vue?vue&type=template&id=283d2d92&scoped=true&"
import script from "./EstimateTemplateNew.vue?vue&type=script&lang=js&"
export * from "./EstimateTemplateNew.vue?vue&type=script&lang=js&"
import style0 from "./EstimateTemplateNew.vue?vue&type=style&index=0&id=283d2d92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283d2d92",
  null
  
)

export default component.exports